import {
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  UnorderedList,
  ListItem,
  VStack
} from '@chakra-ui/react'

interface IReviewSummaryItem {
  id: number | string
  stepName: string
  changes: string[]
}

interface IReviewSummaryModalProps {
  isOpen: boolean
  onClose: () => void
  totalChanges: number
  planName: string
  items: IReviewSummaryItem[]
}

const ReviewSummaryModal = ({ isOpen, onClose, totalChanges, planName, items }: IReviewSummaryModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <ModalHeader fontSize="18px" color="gray.800" fontWeight={500}>
          Changes summary
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody paddingBottom={6}>
          <Text fontSize="15px" color="gray.600" marginBottom={4}>
            {totalChanges} changes on{' '}
            <Text as="span" fontWeight={600} color="gray.800">
              {planName}
            </Text>
          </Text>
          <VStack align="stretch" spacing={3}>
            {items.map((item, index) => (
              <HStack key={`${item.id}-${index}`} align="flex-start" spacing={4}>
                <Text fontWeight={600} color="gray.800" minW="260px">
                  {item.id}. {item.stepName}
                </Text>
                <UnorderedList margin={0} marginTop="2px" spacing={1} paddingLeft={4}>
                  {item.changes.map((change, changeIndex) => (
                    <ListItem key={`${item.id}-${changeIndex}`} fontSize="14px" color="gray.600">
                      {change}
                    </ListItem>
                  ))}
                </UnorderedList>
              </HStack>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ReviewSummaryModal

